import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTravelProductStart,
  getTravelProductSuccess,
  getTravelProductFailure,
} from "../reducers/getTravelProductReducer";
import axios from "axios";
import Cookies from "js-cookie";

export const getTravelProduct = createAsyncThunk(
  "getTravelProduct",
  async ({ typeId }, thunkAPI) => {
    try {
      thunkAPI.dispatch(getTravelProductStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Travel/GettravelProduct?Product_Type=${typeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getTravelProductSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getTravelProductFailure(error.response.data.Message));

      throw error;
    }
  }
);
